import Immutable from 'seamless-immutable';

import { register } from '@src/dispatcher';
import createStore from '@src/stores/StoreUtils';
import ACTION_TYPES from './actionTypes';

class Store {
  state = Immutable({
    title: '',
    posX: null,
    posY: null,
    active: true,
    outputJSON: '',
    inputJSON: '',
    code: '',
    lastEditedTime: '',
    functionName: null,
    edited: false,
    envVariables: [],
  });

  constructor() {
    this.reducer = this.reducer.bind(this);
    this.registrer = this.registrer.bind(this);
    this.getState = this.getState.bind(this);
    this.getStateImmutable = this.getStateImmutable.bind(this);
    this._Store = createStore(this.state);
    this._Store.dispatchToken = register(this.registrer);
  }

  registrer(props) {
    this.state = this.reducer(props);
    this._Store.emitChange();
  }

  reducer({ action, type: actionType }) {
    const { state } = this;
    switch (actionType) {
      case ACTION_TYPES.RECEIVED_CODENODE_DATA:
        return state.merge({
          title: action.title,
          posX: action.posX,
          posY: action.posY,
          active: action.active,
          outputJSON: action.outputJSON,
          inputJSON: action.inputJSON,
          lastEditedTime: action.lastEditedTime,
          functionName: action.functionName,
          code: action.code,
        });

      case ACTION_TYPES.UPDATE_CODENODE_DATA:
        return state.merge({
          title: action.title,
          posX: action.posX,
          posY: action.posY,
          active: action.active,
          outputJSON: action.outputJSON,
          code: action.code,
          edited: true,
        });

      case ACTION_TYPES.SAVE_CODENODE_DATA:
        return state.merge({
          edited: false,
        });

      case ACTION_TYPES.RESET_CODENODE_DATA:
        return state.merge({
          title: '',
          active: true,
          outputJSON: '',
          inputJSON: '',
          code: '',
          lastEditedTime: '',
          edited: false,
          functionName: null,
          envVariables: [],
        });

      case ACTION_TYPES.SET_CODENODE_COORDS:
        return state.merge({
          posX: action.posX,
          posY: action.posY,
        });

      case ACTION_TYPES.UPDATE_EDITOR_DATA:
        return state.merge({
          functionName: action.functionName,
          code: action.code,
          inputJSON: action.inputJSON,
        });

      case ACTION_TYPES.SET_ENV_VARIABLES:
        return state.merge({
          envVariables: action.envVariables,
        });

      case ACTION_TYPES.RESET_ENV_VARIABLES:
        return state.merge({
          envVariables: [],
        });

      default:
        return state;
    }
  }

  getState() {
    return this.state;
  }

  getStateImmutable() {
    return this.state;
  }

  getStore() {
    return this._Store;
  }
}

export default new Store();
